import React from 'react';

import classNames from 'classnames';

import placeholderImage from 'assets/icons/placeholderImage.svg';
import './styles.css';

const LocationBox = ({
  location: {name, image, ref, address: {city, country}},
  className,
  onClick
}) => {
  const imageUrl = image || placeholderImage;

  return (
    <div className={classNames('LocationBox', className)}>
      <div
        className="LocationBox__image colab-clickable"
        style={{backgroundImage: `url(${imageUrl}?w=300&h=300&fit=crop)`}}
        onClick={() => onClick(ref)}
      />
      <div className="LocationBox__info">
        <div className="LocationBox__name colab-bold">{name}</div>
        <div className="LocationBox__address">
          {city}, {country}
        </div>
      </div>
    </div>
  );
};

export default LocationBox;
